import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useVoiceAnalyses from 'hooks/useVoiceAnalyses';
import { voiceAnalysesSelectors } from "features/voiceAnalyses";

const VoiceAnalysesList = () => {
  const { getVoiceAnalyses } = useVoiceAnalyses();
  const { data, pagination } = useCustomSelector(voiceAnalysesSelectors.getVoiceAnalysesData);
  const fetching = useCustomSelector(voiceAnalysesSelectors.voiceAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getVoiceAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <VoiceAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);